'use client';

import type { FC, PropsWithChildren, SyntheticEvent } from 'react';
import { createContext, useContext } from 'react';

import type { OfferData } from '@wwe-portal/entities/offer.type';

import type { OfferCardProps } from '../type';

export interface OfferContextValue {
  offerToProps: (offer: OfferData) => OfferCardProps;
  onBannerClick: () => void;
  onBannerMoreClick: () => void;
  onOfferClick: (offerData: OfferData, e: SyntheticEvent) => void;
  onOfferPriceClick: (offerData: OfferData, e: SyntheticEvent) => void;
}
export const OfferContext = createContext<OfferContextValue | null>(null);
export const OfferProvider: FC<PropsWithChildren<OfferContextValue>> = ({
  children,
  ...value
}) => {
  return (
    <OfferContext.Provider value={value}>{children}</OfferContext.Provider>
  );
};

export const useOfferContext = () => {
  const context = useContext(OfferContext);
  if (context == null) throw new Error('context is null');
  return context;
};
